<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

function showEvents() {
  router.push('/events');
}
function showSources() {
  router.push('/events/sources');
}

function getPage(path: string): string {
  switch (path) {
    case '/events':
      return 'List';
    case '/events/sources':
      return 'Sources';
  }
  return '';
}
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Events', getPage(route.path)]" />
    <v-btn
      flat
      v-if="route.path !== '/events/sources'"
      color="info"
      @click="showSources"
      >Sources</v-btn
    >
    <v-btn flat v-if="route.path !== '/events'" color="info" @click="showEvents"
      >List</v-btn
    >
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
